// extracted by mini-css-extract-plugin
module.exports = {"athlete-description":"Athlete_athlete-description__KWnnF","table":"Athlete_table___CNzd"};